import { createReducer, on } from "@ngrx/store";
import { CalendarStateInterface } from "./calendarState.interface";
import { invokeCalendarLaunch, resultCalendarLaunch } from "./calendar.actions";

export const initialState: Readonly<CalendarStateInterface> = {
  launching: false,
};

export const CalendarReducer = createReducer(
  initialState,
  on(invokeCalendarLaunch, (state) => ({
    ...state,
    launching: true,
  })),
  on(resultCalendarLaunch, (state) => ({
    ...state,
    launching: false,
  }))
);
